import '../../style/index.less';
import './index.less'; // style dependencies
// deps-lint-skip: menu

import '../../empty/style';
import '../../radio/style';
import '../../checkbox/style';
import '../../dropdown/style';
import '../../spin/style';
import '../../pagination/style';
//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/table/style/index.js
// module id = 809
// module chunks = 0